import { LogicoMapBase } from './LogicoMapBase';
import { MapPlaces } from '../../pdf/map';
import { ELogicoVariant } from '../../pdf/board/logico';

// ============================================
// Piccolo Map Generators
// ============================================

/**
 * Piccolo map - Czech regions
 */
export class Piccolo_Mapa__CR__Kraje extends LogicoMapBase {
  constructor() {
    super(ELogicoVariant.Piccolo, 'map/map-cs.zip', MapPlaces.kraje());
  }
}

/**
 * Piccolo map - Czech regional capital cities
 */
export class Piccolo_Mapa__CR__KrajskaMesta extends LogicoMapBase {
  constructor() {
    super(ELogicoVariant.Piccolo, 'map/map-cs.zip', MapPlaces.krajskaMesta());
  }
}

/**
 * Piccolo map - European capital cities
 */
export class Piccolo_Mapa__Evropa__HlavniMesta extends LogicoMapBase {
  constructor() {
    super(ELogicoVariant.Piccolo, 'map/map-europe.zip', MapPlaces.hlavniEvropskaMesta());
  }
}

/**
 * Piccolo map - Olomouc region points of interest
 */
export class Piccolo_Mapa__OlomouckyKraj__Zajimavosti extends LogicoMapBase {
  constructor() {
    super(
      ELogicoVariant.Piccolo,
      'map/map-cs-kraj-olomoucky.zip',
      MapPlaces.olomouckyKrajZajimavosti()
    );
  }
}

/**
 * Piccolo map - World countries/capitals
 */
export class Piccolo_Mapa__Svet__Staty extends LogicoMapBase {
  constructor() {
    super(ELogicoVariant.Piccolo, 'map/map-world.zip', MapPlaces.staty());
  }
}

// ============================================
// Primo Map Generators
// ============================================

/**
 * Primo map - Czech regions
 */
export class Primo_Mapa__CR__Kraje extends LogicoMapBase {
  constructor() {
    super(ELogicoVariant.Primo, 'map/map-cs.zip', MapPlaces.kraje());
  }
}

/**
 * Primo map - Czech regional capital cities
 */
export class Primo_Mapa__CR__KrajskaMesta extends LogicoMapBase {
  constructor() {
    super(ELogicoVariant.Primo, 'map/map-cs.zip', MapPlaces.krajskaMesta());
  }
}

/**
 * Primo map - European capital cities
 */
export class Primo_Mapa__Evropa__HlavniMesta extends LogicoMapBase {
  constructor() {
    super(ELogicoVariant.Primo, 'map/map-europe.zip', MapPlaces.hlavniEvropskaMesta());
  }
}

/**
 * Primo map - Olomouc region points of interest
 */
export class Primo_Mapa__OlomouckyKraj__Zajimavosti extends LogicoMapBase {
  constructor() {
    super(
      ELogicoVariant.Primo,
      'map/map-cs-kraj-olomoucky.zip',
      MapPlaces.olomouckyKrajZajimavosti()
    );
  }
}

/**
 * Primo map - World countries/capitals
 */
export class Primo_Mapa__Svet__Staty extends LogicoMapBase {
  constructor() {
    super(ELogicoVariant.Primo, 'map/map-world.zip', MapPlaces.staty());
  }
}

// ============================================
// Maximo Map Generators
// ============================================

/**
 * Maximo map - Czech regions
 */
export class Maximo_Mapa__CR__Kraje extends LogicoMapBase {
  constructor() {
    super(ELogicoVariant.Maximo, 'map/map-cs.zip', MapPlaces.kraje());
  }
}

/**
 * Maximo map - Czech regional capital cities
 */
export class Maximo_Mapa__CR__KrajskaMesta extends LogicoMapBase {
  constructor() {
    super(ELogicoVariant.Maximo, 'map/map-cs.zip', MapPlaces.krajskaMesta());
  }
}

/**
 * Maximo map - European capital cities
 */
export class Maximo_Mapa__Evropa__HlavniMesta extends LogicoMapBase {
  constructor() {
    super(ELogicoVariant.Maximo, 'map/map-europe.zip', MapPlaces.hlavniEvropskaMesta());
  }
}

/**
 * Maximo map - World countries/capitals
 */
export class Maximo_Mapa__Svet__Staty extends LogicoMapBase {
  constructor() {
    super(ELogicoVariant.Maximo, 'map/map-world.zip', MapPlaces.staty());
  }
}
